// extracted by mini-css-extract-plugin
module.exports = {"container":"PageSpinner_container__C7fRI","fluid":"PageSpinner_fluid__1RW9m"};